import { z } from 'zod'
import type { Address } from '~/domain/shared/address/models/Address'
import { StateNames } from '~/domain/shared/address/models/City'

const ibgeCodeSchema = z.preprocess(
  value => (value == null ? value : String(value)),
  z.string().nullish()
) as z.ZodType<string | null | undefined>

export const AddressDTO = z.object({
  id: z.number().nullish(),
  street: z.string().nullish(),
  number: z.string().nullish(),
  complement: z.string().nullish(),
  neighborhood: z.string().nullish(),
  zip_code: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  city_id: z.number().nullish(),
  ibge_code: ibgeCodeSchema
})

export type AddressDTO = z.infer<typeof AddressDTO>

export function mapDTOToAddress (dto: AddressDTO): Address {
  const city =
    dto.city_id != null && dto.city != null && dto.state != null
      ? {
          id: dto.city_id,
          name: dto.city,
          state: dto.state as StateNames,
          externalCode: dto.ibge_code ?? undefined
        }
      : undefined

  return {
    complement: dto.complement ?? undefined,
    neighborhood: dto.neighborhood ?? undefined,
    number: dto.number ?? undefined,
    street: dto.street ?? undefined,
    zipcode: dto.zip_code ?? undefined,
    city
  }
}

export function mapAddressToDTO (model: Address): AddressDTO {
  return {
    id: model.id,
    street: model.street,
    city_id: model.city?.id,
    state: model.city?.state,
    number: model.number,
    ibge_code: model.city?.externalCode,
    neighborhood: model.neighborhood,
    complement: model.complement,
    zip_code: model.zipcode?.replaceAll(/\D/g, '')
  }
}
